package dk.smark.demo.map

import androidx.compose.ui.graphics.ImageBitmap
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.statement.readRawBytes

private val client = HttpClient()
private val cache = mutableMapOf<String, ImageBitmap>()

suspend fun loadTile(x: Int, y: Int, zoom: Int): ImageBitmap? {
    val url = TileMath.tileUrl(x, y, zoom)
    cache[url]?.let { return it }
    return try {
        val bytes = client.get(url).readRawBytes()
        val bitmap = decodeImageBitmap(bytes)
        cache[url] = bitmap
        bitmap
    } catch (e: Exception) {
        null
    }
}

expect fun decodeImageBitmap(bytes: ByteArray): ImageBitmap